export default "__VITE_PUBLIC_ASSET__411ddeb6__"